import { render, staticRenderFns } from "./person-responsible-grid-new.vue?vue&type=template&id=a5b60272&scoped=true"
import script from "./person-responsible-grid-new.vue?vue&type=script&lang=js"
export * from "./person-responsible-grid-new.vue?vue&type=script&lang=js"
import style0 from "./person-responsible-grid-new.vue?vue&type=style&index=0&id=a5b60272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../CrossD.Portal.Vue/ClientApp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b60272",
  null
  
)

export default component.exports